import Vuex from 'vuex';
import Vue from 'vue';
Vue.use(Vuex);
import {emailStore} from "@components/emails/store";
import {orderStore} from '@orders/store';
import {offerStore} from "@orders/subpages/Offer/store";
import {axiosByMethod, post} from "@api";
import {notifyError} from "@components/Notification";
import {currentUser, extractBodyContent, extractJson, replaceBodyContent} from "@utilities/functions";

const aiStore = {
    state: {
        isSending: false,
        promptText: '',
        promptIsDisabled: true,
        currentAction: null,
        data: {
            model: "gpt-5.2",
            messages: [],
        },
        runOnResponse: {
            addOrderElements: 'processItineraryToAdd',
        },
        suggestions: {
            chat: {
                clear: true,
                model: "gpt-5.2",
                label: 'ChatGPT',
                messages: [
                    {
                        "key": 'chat' + new Date(),
                        "forApi": true,
                        "isVisible": false,
                        "role": "system",
                        "content": "Answer should be formatted in html with inline style attributes. Do NOT change family, size and color of the font.",
                    },
                    {
                        "key": 'write-1-' + new Date(),
                        "forApi": false,
                        "isVisible": true,
                        "role": "assistant",
                        "content": "Was kann ich für dich tun?",
                    },
                ],
                callAction: ['enableChat']
            },
            /*addOrderElements: {
                clear: true,
                model: "gpt-5.2",
                label: 'Reise aufnehmen',
                messages: [
                    {
                        "key": 'addOrderElements' + new Date(),
                        "forApi": true,
                        "isVisible": false,
                        "role": "system",
                        "content": "You are a specialized travel itinerary parser. Your task is to receive a textual itinerary (in any form, such as paragraphs, bullet points, numbered lists, or with dates) and convert it into a structured JSON format.\n" +
                            "\n" +
                            "Follow these instructions:\n" +
                            "\n" +
                            "1. Analyze the input text carefully.\n" +
                            "2. Each day of the itinerary should be structured as a separate object within a \"days\" array.\n" +
                            "3. Each day object should contain:\n" +
                            "   - a \"position\" field representing the day's numerical order.\n" +
                            "   - a \"name\" field. If a headline or clear title for the day is provided, use it, excluding any numeric or date prefix. If no headline is given, leave it as an empty string.\n" +
                            "4. Each day should include an array called \"elements\".\n" +
                            "5. Each sentence or clear individual activity from the itinerary description should become an object within the \"elements\" array, with a field called \"name\" containing the activity or description text.\n" +
                            "\n" +
                            "The resulting JSON must follow this exact structure:\n" +
                            "\n" +
                            "{\n" +
                            "  \"days\": [\n" +
                            "    {\n" +
                            "      \"position\": 1,\n" +
                            "      \"name\": \"HEADLINE OF THE DAY IF AVAILABLE OTHERWISE BLANK\",\n" +
                            "      \"elements\": [\n" +
                            "        {\"name\": \"FIRST ACTIVITY OR DESCRIPTION OF THE DAY\"},\n" +
                            "        {\"name\": \"SECOND ACTIVITY OR DESCRIPTION OF THE DAY\"}\n" +
                            "      ]\n" +
                            "    },\n" +
                            "    {\n" +
                            "      \"position\": 2,\n" +
                            "      \"name\": \"NEXT DAY'S HEADLINE IF AVAILABLE OTHERWISE BLANK\",\n" +
                            "      \"elements\": [\n" +
                            "        {\"name\": \"ACTIVITY OR DESCRIPTION OF THE DAY\"}\n" +
                            "      ]\n" +
                            "    }\n" +
                            "  ]\n" +
                            "}\n" +
                            "\n" +
                            "Respond exclusively with a valid JSON object, not as a string. The JSON must be presented directly, using standard JSON formatting (with indentation and line breaks), but do not escape any characters. Do not wrap the response in quotation marks. Do not include code fences (like ```), language tags, or any additional explanation. Output only the raw JSON object.",
                    },
                    {
                        "key": 'write-1-' + new Date(),
                        "forApi": false,
                        "isVisible": true,
                        "role": "assistant",
                        "content": "Bitte lade ein Dokument hoch oder schreibe den Routenverlauf in das Chatfenster.",
                    },
                ],
                callAction: ['enableChat'],
                callOnResponseAction: ['sentItineraryToAdd']
            },*/
            writeEmailFromInput: {
                clear: true,
                label: 'Text formulieren',
                messages: [
                    {
                        "key": 'french-1-' + new Date(),
                        "forApi": true,
                        "isVisible": false,
                        "role": "system",
                        "content": "Answer should be formatted in html with inline style attributes. Do NOT change family, size and color of the font. Write a text based on the input of the user",
                    },
                    {
                        "key": 'write-1-' + new Date(),
                        "forApi": true,
                        "isVisible": true,
                        "role": "assistant",
                        "content": "Bitte gib mir einige Stichworte oder Anweisungen, damit ich weiß worüber ich einen Text schreiben soll.",
                    },
                ],
                callAction: ['enableChat']
            },
            french: {
                label: 'Französisch',
                messages: [
                    {
                        "response_format": {type: "json"},
                        "key": 'french-1-' + new Date(),
                        "forApi": true,
                        "isVisible": true,
                        "role": "user",
                        "content": "Bitte Email ins Französische übersetzen",
                    },
                ],
                callAction: ['addEmailToChat'],
            },
            english: {
                label: 'Englisch',
                messages: [
                    {
                        "response_format": {type: "json"},
                        "key": 'french-1-' + new Date(),
                        "forApi": true,
                        "isVisible": true,
                        "role": "user",
                        "content": "Bitte Email ins Englische übersetzen",
                    },
                ],
                callAction: ['addEmailToChat'],
            },
            checkGrammar: {
                label: 'Rechtschreibung prüfen',
                clear: true,
                model: "gpt-5.2",
                messages: [
                    {
                        "response_format": {type: "json"},
                        "key": 'message-check-Email-1-' + new Date(),
                        "forApi": true,
                        "isVisible": false,
                        "role": "system",
                        "content": "Please correct spelling and grammar of the properties \"textHtml\"  and \"subject\" of a JSON object. Return your answer in the same JSON format without additional text.",
                    },
                    {
                        "key": 'message-check-Email-2-' + new Date(),
                        "forApi": false,
                        "isVisible": true,
                        "role": "user",
                        "content": "Bitte Email auf Rechtschreibung und Grammatik überprüfen",
                    },
                ],
                callAction: ['addEmailToChat'],

            },
            translateOrder: {
                label: 'Auswahl übersetzen',
                clear: true,
                model: "gpt-5.2",
                messages: [],
                callAction: ['translateOrder'],
            },
            translateEmail: {
                label: 'Email übersetzen',
                clear: true,
                model: "gpt-5.2",
                messages: [
                    {
                        "response_format": {type: "json"},
                        "key": 'message-translate-Email-1-' + new Date(),
                        "forApi": true,
                        "isVisible": false,
                        "role": "system",
                        "content": "Translate the properties \"textHtml\" and \"subject\" of a JSON object. Return your answer in the same JSON format without additional text.",
                    },
                    {
                        "response_format": {type: "json"},
                        "key": 'message-translate-Email-2-' + new Date(),
                        "forApi": false,
                        "isVisible": true,
                        "role": "user",
                        "content": "Ich möchte meine Email übersetzen",
                    },
                    {
                        "key": 'message-translate-Email-3-' + new Date(),
                        "forApi": false,
                        "isVisible": true,
                        "role": "assistant",
                        "content": "In welche Sprache soll die Email übersetzt werden (Achtung aktuell Email wird überschrieben)?",
                        suggestions: [
                            'french', 'english'/*, 'german', 'english', 'spanish'*/
                        ],
                    },
                ]
            }
        },
        startHelp: {
            default: {
                messages: [
                    {
                        "key": 'message-start-default-1-' + new Date(),
                        "forApi": false,
                        "isVisible": true,
                        "role": "assistant",
                        "content": "Hallo " + (currentUser() ? currentUser().firstName: '') + "! \n" + "Ich bin noch in der Beta-Phase und habe für diese Seite noch keine speziellen Funktionen. Du kannst aber mit mir chatten und so die normalen Chat-GPT-Funktionen nutzen.",
                        suggestions: [
                            'chat', /*'addOrderElements', 'writeEmailFromInput', 'writeResponseFromFAQ', 'changeTone', 'checkGrammar'*/
                        ],
                    },
                ],
            },
            email: {
                messages: [
                    {
                        "key": 'message-start-email-2-' + new Date(),
                        "forApi": false,
                        "isVisible": true,
                        "role": "assistant",
                        "content": "Hallo " + (currentUser() ? currentUser().firstName: '') + "! Ich bin noch in der Beta Phase, aber sehe, dass du eine Email schreiben möchtest. Vielleicht kann ich dir dabei helfen?",
                        suggestions: [
                            'translateEmail', 'checkGrammar', 'writeEmailFromInput', 'chat'/*, 'writeEmailFromInput', 'writeResponseFromFAQ', 'changeTone', 'checkGrammar'*/
                        ],
                    },
                ],
            },
            orderTranslation: {
                messages: [
                    {
                        "key": 'message-start-email-2-' + new Date(),
                        "forApi": false,
                        "isVisible": true,
                        "role": "assistant",
                        "content": "Hallo " + (currentUser() ? currentUser().firstName: '') + "! Ich werde dir bei der Übersetzung der freien Texte helfen. Bitte wähle die Elemente aus, die du übersetzen möchtest. Achtung: Die ausgewählten Elemente werden mit der Übersetzung überschrieben.",
                        checkboxes: [
                            'Tagesüberschriften', 'Freitexte in den Tagen', 'Reisetitel', 'Freitexte in der Kalkulation', 'Hinweise im Anschreiben', 'Ausschreibungstexte'
                        ],
                        checkBoxValues: ['Tagesüberschriften', 'Freitexte in den Tagen', 'Reisetitel', 'Freitexte in der Kalkulation', 'Hinweise im Anschreiben'],
                        suggestions: [
                            'translateOrder'
                        ],
                    },
                ],
            },
            clientInvoiceTranslation: {
                messages: [
                    {
                        "key": 'message-start-client-invoice' + new Date(),
                        "forApi": false,
                        "isVisible": true,
                        "role": "assistant",
                        "content": "Hallo " + (currentUser() ? currentUser().firstName: '') + "! Ich werde dir bei der Übersetzung der freien Texte helfen. Bitte wähle die Elemente aus, die du übersetzen möchtest. Achtung: Die ausgewählten Elemente werden mit der Übersetzung überschrieben.",
                        checkboxes: [
                            'Freitexte in der Kundenrechnung'
                        ],
                        checkBoxValues: ['Freitexte in der Kalkulation'],
                        suggestions: [
                            'translateOrder'
                        ],
                    },
                ],
            }
        },
    },


    mutations: {

    },

    actions: {
        enableChat({state}) {
            state.promptIsDisabled = false;
        },

        sendPrompt({ state, dispatch }) {
            state.isSending = true;
            state.data.messages.push(
                {
                    "key": 'prompt-' + new Date(),
                    "forApi": true,
                    "isVisible": true,
                    "role": "user",
                    "content": state.promptText,
                }
            );
            state.promptText = '';
            dispatch('chat');
        },

        sendRequestToAI({state}) {
            return post('open_ai/chat', {...state.data, messages: state.data.messages.filter(message => message.forApi)})
        },

        makeApiCall(state, {method, api, data = {}, params = {}}) {
            return axiosByMethod(method, api, data, params)
        },

        chat({ state, dispatch }) {
            state.isSending = true;
            dispatch('sendRequestToAI').then(response => {
                state.isSending = false;
                if(state.runOnResponse[state.currentAction]) {
                    dispatch(state.runOnResponse[state.currentAction], response)
                } else {
                    state.data.messages.push({...response.data.choices[0].message, isVisible: true, forApi: true, key: new Date()})
                }
            }, error => {
                state.isSending = false;
                notifyError('Server Error! Es konnte keine Verbindung mit ChatGpt hergestellt werden!')
            });
        },

        translateOrder ({ state, commit, dispatch, rootState }) {
            state.isSending = true;
            let orderId = rootState.orderStore.orderID;
            if(orderId) {
                dispatch('makeApiCall', {
                    method: 'PUT',
                    api: 'orders/' + orderId + '/translate',
                    params: {
                        _groups: ['trip_read', 'order_offer_read'],
                        toTranslate: state.data.messages[0].checkBoxValues
                    }
                }).then(response => {
                    rootState.orderStore.order.trip.name = response.data.trip.name;
                    rootState.offerStore.offer.introText = response.data.mainOffer.introText;
                    state.isSending = false;
                    state.data.messages.push({
                        "key": 'translate-order-' + new Date(),
                        "forApi": false,
                        "isVisible": true,
                        "role": "assistant",
                        "content": "Übersetzung erfolgreich.",
                    });
                })
            }

        },

        addEmailToChat({ state, commit, dispatch, rootState }) {

            state.data.messages.push(
                {
                    "response_format": {type: "json"},
                    "key": 'addEmailToChat-2' + new Date(),
                    "forApi": true,
                    "isVisible": false,
                    "role": "user",
                    "isEmail": true,
                    "content": JSON.stringify({textHtml: extractBodyContent(rootState.emailStore.newEmail.textHtml), subject: rootState.emailStore.newEmail.subject}),
                }
            )
            state.isSending = true;
            rootState.emailStore.isLoadingPreview = true;
            rootState.emailStore.emailManuallyChanged = true;

            dispatch('sendRequestToAI').then(response => {
                let email = JSON.parse(extractJson(response.data.choices[0].message.content))
                rootState.emailStore.newEmail.subject = email.subject
                rootState.emailStore.newEmail.textHtml = replaceBodyContent(rootState.emailStore.newEmail.textHtml, email.textHtml);
                rootState.emailStore.isLoadingPreview = false;
                state.isSending = false;
                state.data.messages = [{
                    "key": 'done-1' + new Date(),
                    "forApi": false,
                    "isVisible": true,
                    "role": "assistant",
                    "content": "Aufgabe erledigt!",
                }];
                state.data.messages.push(...state.startHelp.email.messages)
            });
        }
    },

    getters: {

    }
}
const store = new Vuex.Store({
    modules: {
        emailStore: emailStore,
        aiStore:aiStore,
        orderStore: orderStore,
        offerStore: offerStore,
    }
});



export { store };

export default store;
